import { ArrowLeftIcon, UserIcon } from "components/Icons";
import Navbar from "./Navbar";

const Layout = ({ children, title, handleClick }) => {
  const Logo = () => {
    return (
      <div className="flex justify-between items-center w-full px-4 border-b border-gray-600 mb-5 pb-2 mt-2">
        <a href="/" rel="noopener noreferrer">
          <img
            src={"https://www.presik.com/static/media/logo-white.13ac1f7e.webp"}
            className="h-14  rounded-full object-cover"
          />
        </a>
        <a href="/" rel="noopener noreferrer">
          <ArrowLeftIcon className="size-7 fill-current rounded-full bg-white p-1 text-gray-800 " />
        </a>
      </div>
    );
  };

  const UserSection = () => {
    return (
      <div className="border-t-2 py-2 border-white flex justify-start items-center  space-x-5 bg-yellow-500 text-gray-800 px-5">
        <div className="">
          <span className="font-semibold truncate text-md text-left">
            Docs v1 by PRESIK
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="w-screen h-screen flex overflow-hidden overflow-x-hidden max-w-screen">
      <div className="w-1/5  bg-gray-800  flex flex-col justify-between h-full border-r-2 border-yellow-500">
        <div>
          <Logo />
          <Navbar handleClick={(e) => handleClick(e)} />
        </div>
        <UserSection />
      </div>
      <div className="w-4/5 p-4 overflow-y-scroll overflow-x-hidden max-w-full">
        <div className="w-full border-b border-gray-300 mb-5 pb-2">
          <span className="text-semibold text-2xl">{title && title}</span>
        </div>
        <div className="overflow-x-hidden">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
